export default __webpack_public_path__ + "/dist/images/image00023.7ad0e23de5264c38e0e84c8c6732448d.jpg";